import React from 'react'
import { Button } from '@progress/kendo-react-buttons'
import { SearchBody } from '../../../components/layouts'
import CodeNameSearchCondition from './CodeNameSearchCondition'
import CodeNameSearchResultList from './CodeNameSearchResultList'
import { Window } from '@progress/kendo-react-dialogs'

import CodeNameInput from './CodeNameInput'
import { useAccessibleAuthority, usePageTitle } from '../../../components/hooks'
import { Authority } from '../../../gateway/system/Authority'

export default function CodeNameSearch() {
  useAccessibleAuthority(Authority.Builder, Authority.Material, Authority.Branch)
  usePageTitle('コード名称マスタメンテナンス')

  const [showMaintenanceDialog, setShowMaintenanceDialog] = React.useState(false)

  const toggleMaintenanceDialog = () => {
    setShowMaintenanceDialog(!showMaintenanceDialog)
  }

  return (
    <SearchBody
      leftPane={<CodeNameSearchCondition />}
      rightPane={<CodeNameSearchResultList />}
      rightPaneButton={
        <>
          <Button onClick={() => ''}>戻る</Button>
          <Button onClick={toggleMaintenanceDialog} themeColor="primary">
            新規追加
          </Button>

          {showMaintenanceDialog && (
            <Window title={'コード名称マスタメンテナンス　新規'} onClose={toggleMaintenanceDialog} initialWidth={1366} initialHeight={650} modal>
              <CodeNameInput />
              <div
                style={{
                  marginTop: '10px',
                  display: 'flex',
                  justifyContent: 'flex-end'
                }}
              ></div>
            </Window>
          )}
        </>
      }
    />
  )
}
